import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@cjmobiledetailing.com");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (ex) {
      const d = ex?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0f17]">
      <Navbar />
      <section className="mx-auto max-w-md px-4 sm:px-6 lg:px-8 py-16" data-testid="admin-login-section">
        <div className="cj-card p-8">
          <div className="h-12 w-12 rounded-xl bg-[#ff6b00]/10 flex items-center justify-center">
            <Lock className="h-6 w-6 text-[#ff6b00]" />
          </div>
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#ff6b00] mt-4">
            Admin Portal
          </div>
          <h1 className="font-display mt-2 text-3xl font-extrabold uppercase text-slate-100">
            Sign in to the CRM
          </h1>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email-input"
                className="mt-2 w-full bg-[#0f1522] border border-white/10 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-[#ff6b00]"
                required
              />
            </div>
            <div>
              <label className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password-input"
                className="mt-2 w-full bg-[#0f1522] border border-white/10 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-[#ff6b00]"
                required
              />
            </div>
            {err && (
              <div data-testid="admin-login-error" className="text-sm text-red-400 font-mono uppercase tracking-wider">
                {err}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit-button"
              className="cj-btn-primary w-full px-6 py-3 rounded-full inline-flex items-center justify-center gap-2"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              Sign In
            </button>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
}
